import React, { memo } from 'react';
import styled from 'styled-components';
import isString from 'lodash/isString';

import { toRem } from '@front/common/src/utils/styles';
import { NOOP } from '@front/common/src/utils/noop';

import { getSrcSet } from '../../utils/image';

const StyledImage = styled.img<{
  width: number | string;
  height: number | string;
  onClick: () => void;
}>`
  width: ${(props) => (isString(props.width) ? props.width : toRem(props.width))};
  height: ${(props) => (isString(props.height) ? props.height : toRem(props.height))};
  cursor: ${(props) => (props.onClick === NOOP ? 'inherit' : 'pointer')};
`;

export type ImageProps = {
  alt: string;
  src: string;
  double?: string;
  triple?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  onClick?: () => void;
};

// ⚠️ consider using the CloudImage component if possible ⚠️
const Image = ({
  alt,
  src,
  double,
  triple,
  width = 'auto',
  height = 'auto',
  className,
  onClick = NOOP,
}: ImageProps) => (
  <StyledImage
    alt={alt}
    src={src}
    width={width}
    height={height}
    srcSet={getSrcSet(src, double, triple)}
    className={className}
    onClick={onClick}
  />
);

export default memo(Image);
